/*
1. 接收 string 或 array
2. 自動斷行（以 <br> 處理）
3. 回傳結構化陣列，讓你 v-for 使用
*/ 

export function useFormat(input) {
  return computed(() => {
    const lines = Array.isArray(input)
      ? input
      : typeof input === 'string'
        ? input.split(/\r?\n/)
        : []

    const result = []

    lines.forEach((line, lineIndex) => {
      const parts = line.split(/([\dA-Za-z]+)/g) // 拆成英數與非英數

      parts.forEach((text, index) => {
        if (!text) return
        const isEn = /^[\dA-Za-z]+$/.test(text)

        result.push({
          text,
          lang: isEn ? 'en' : null,
          isLineBreak: false
        })
      })

      // 加上換行（非最後一行才加）
      if (lineIndex < lines.length - 1) {
        result.push({
          text: '',
          lang: null,
          isLineBreak: true
        })
      }
    })

    return result
  })
}


